import {JSEP} from "./jsep-library";
import jsep from 'jsep';
/**
 *
 *
 *
 */
export module conditions {

	export function is_touch_device() : boolean {
		return 'ontouchstart' in window        // works on most browsers
			|| !!navigator.maxTouchPoints;       // works on IE10/11 and Surface
	}

	export interface ILiterals {
		TOUCH : boolean;
		COMBINED_LAYERS : boolean;
	}


	// const literals = {
	// 	/*TABLET: false,
	// 	MOBILE: false,
	// 	DESKTOP: true,*/
	//
	// 	TOUCH: is_touch_device()
	// };

	function evaluateAST(ast : JSEP.Node, literals : {}) : any {
		switch (ast.type) {
			case 'Identifier':
				if (ast.name in literals) {
					return literals[ast.name];
				}
				throw new Error(`${ast.name} not found in literals`);
			case 'LogicalExpression':
				switch (ast.operator) {
					case '&&':
						return evaluateAST(ast.left, literals) && evaluateAST(ast.right, literals);
					case '||':
						return evaluateAST(ast.left, literals) || evaluateAST(ast.right, literals);
					case '&':
						return evaluateAST(ast.left, literals) & evaluateAST(ast.right, literals);
					case '|':
						return evaluateAST(ast.left, literals) | evaluateAST(ast.right, literals);
					case '^':
						return evaluateAST(ast.left, literals) ^ evaluateAST(ast.right, literals);
				}
				throw new Error(`${ast.operator} is an operator that isn't supported`)
			case 'UnaryExpression':
				switch (ast.operator) {
					case '!':
						return !evaluateAST(ast.argument, literals);
				}
				throw new Error(`${ast.operator} is an operator that isn't supported`)
			default:
				throw new Error(`${ast.type} is an expression that isn't supported`)

		}
	}

	export function evalConditions(expression : string, literals : ILiterals) : boolean {
		let AST = jsep(expression);
		return evaluateAST(AST, literals);
	}
}
